module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9532_red.de4ab231.jpg";